// extracted by mini-css-extract-plugin
module.exports = {"box_right_title":"box_right_title-1YjLdQjp"};